<template>
    <div class="works-page">
        <section class="top-contentBox">
            <h1 class="page-title_top centerText mar-btm-130">
                Maximise your Employee Value Proposition with Beny
            </h1>
            <p class="page-top_message centerText marginText">
                Beny simplifies and streamlines (real) employee benefits to cultivate a positive work environment. A place <br/>where people genuinely want to work at, and stay at.
            </p>
            <!-- <div class="default_Btn w164" @click="openSeeHow">See how</div> -->
            <div class="topLong_icon"></div>
        </section>
        <section class="middle-contentBox">
            <div class="mid_center">
                <div class="new_tips centerText">
                    Designed to be a seamless part of your organisation’s daily life, we make our benefits simple to integrate, accessible to many, all in one place.
                    <p class="height_box"></p>
                    Members get access to exclusive perks and insights that enhance their physical, mental, social, and financial wellbeing. All in one App.
                    <p class="height_box"></p>
                    The future of your team’s happiness and engagement starts here.
                </div>
                <div class="mid_btmBox">
                    <div class="mid_btmLeft">
                        <div class="bold_primaryText" style="margin-bottom:40px;padding-top:160px">
                            Sign up your organisation in as little as <br/>a few clicks
                        </div>
                        <!--<p class="primaryText margin_mid">
                            Lorem ipsum dolor sit amet, consectetur <br/>
                            adipiscing elit. Aliquam sit amet vehicula orci. <br/>
                            Duis sed laoreet erat. Integer rutrum metus ex.
                        </p>-->
                        <div class="default_Btn w242" @click="$router.push('/registered')">Sign up now</div>
                    </div>
                    <img class="mid_btmRight" src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/5239dd4e80bb42b884185bf83a2de234.png" />
                </div>
            </div>
        </section>
        <div class="svgLine_box">
            <svg
            preserveAspectRatio="none"
            viewBox="-450 -450 900 900"
            xmlns="http://www.w3.org/2000/svg"
            style="fill:#302E2C; width: 100%; height: 90px;"
            >
                <path d='M-466,-11 C0,-769 381,-148 453,-5'/>
            </svg>
        </div>
        <section class="footer-contentBox">
            <div class="fot_center">
                <div class="footer_cardBox">
                    <img src="../../assets/works/footer1.png" class="footerCard_img left31" alt="">
                    <div class="footCard_item leftAuto">
                        <div class="bold_primaryText title-margin">
                            Onboard your employees in minutes via a<br />couple of super easy steps
                        </div>
                        <!-- <div class="pfp-txt">
                            <span>Lucas Horne</span>, Product Manager
                        </div> -->
                        <p class="primaryText margin_fot">
                            And for your team, it's as simple as receiving an email or SMS message from which they download the<br />
                            Beny App to gain access to all of the exclusive benefits.
                        </p>
                        <!-- <div class="dashedLine"></div>
                        <div class="primaryText">
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                            Integer rutrum metus ex."
                        </div>
                        <div class="userInfo_box">
                            <img class="userIcon" src="../../assets/home/checked.png" alt="">
                            Lucas Horne,<div class="userJob_box"> Product Manager</div>
                        </div> -->
                    </div>
                </div>
                <div class="footer_cardBox center_r" style="margin:100px auto 100px auto">
                    <div class="footCard_item">
                        <div class="bold_primaryText marginTop70" style="margin-top:100px">
                            Once you’re in, why not offer a Beny Day to optimise your team’s wellbeing?
                        </div>
                        <!--<p class="primaryText margin_fot">
                            Lorem ipsum dolor sit amet, consectetur <br/>
                            adipiscing elit. Aliquam sit amet vehicula orci. <br/>
                            Duis sed laoreet erat. Integer rutrum metus ex.
                        </p>
                        <div class="dashedLine"></div>
                        <div class="primaryText">
                            "Lorem ipsum dolor sit amet, consectetur adipiscing elit. <br/>
                            Aliquam sit amet vehicula orci. Duis sed laoreet erat. <br/>
                            Integer rutrum metus ex."
                        </div>
                        <div class="userInfo_box">
                            <img class="userIcon" src="../../assets/home/checked.png" alt="">
                            Thomas Stevens,<div class="userJob_box"> UX/UI Designer</div>
                        </div>-->
                    </div>
                    <img src="../../assets/works/footer2.png" class="footerCard_img2 leftAuto" alt="">
                </div>
                <!--<div class="footer_cardBox">
                    <img src="https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/aa7f93a0dba142129bf40246b92ca9c0.png" class="footerCard_img3" alt="">
                    <div class="footCard_item leftAuto">
                        <div class="bold_primaryText marginTop70">
                            Tell everyone about <br/>
                            your great team
                        </div>
                        <p class="primaryText margin_fot">
                            Lorem ipsum dolor sit amet, consectetur <br/>
                            adipiscing elit. Aliquam sit amet vehicula orci. <br/>
                            Duis sed laoreet erat. Integer rutrum metus ex.
                        </p>
                        <div class="default_Btn w222" @click="$router.push('/registered')">Get started</div>
                    </div>
                </div>-->
            </div>
            <div class="fot_middle">
                <div class="fotMid_center">
                    <div class="bold_primaryText">
                        What makes Beny the <br/>workplace friend you <br/>can’t live without?
                    </div>
                    <div class="fotMid_secondBox marginCenter" style="margin: 0 60px;">
                        <div class="beny_cardBox">
                            <img src="../../assets/works/beny1.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                All-In-One Benefits
                            </div>
                            <p class="beny_card-text" style="margin-bottom: 11px;">
                                Beny houses all the best leading benefits in one <br/>
                                convenient and accessible App. Get access to thousands <br/>of big-name benefits through the collective power <br/>of being friends with Beny. <br/>    
                            </p>
                            <p class="beny_card-text">
                                Unlock a whole world of wellness and wellbeing, in the <br/>palm of your hand.
                            </p>
                        </div>
                        <div class="beny_cardBox marginTB" style="margin-bottom: 0;">
                            <img src="../../assets/works/beny2.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                Simple to Enrol, Simple to Use
                            </div>
                            <p class="beny_card-text">
                                Intended to be a seamless integration into daily life, the <br>Beny platform is expertly designed to be super easy for <br>everyone to use (we mean it – everyone). Our intuitive <br>system enables instant enrolment and oversight for <br>company administrators. Because your usual workload <br>is big enough.
                            </p>
                        </div>
                        <!--div class="beny_cardBox">
                            <img src="../../assets/works/beny3.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                It's measurable and <br/>
                                data-driven
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>-->
                    </div>
                    <div class="fotMid_secondBox">
                        <div class="beny_cardBox">
                            <img src="../../assets/works/beny4.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                Insightful Data
                            </div>
                            <p class="beny_card-text">
                                Understand what your team (truly) want and need, with <br>live data and reporting. Already integrated into the Beny <br>platform, you’ll have the insight and the foresight to <br>plan ahead and optimise your employee value<br> proposition.
                            </p>
                        </div>
                        <div class="beny_cardBox marginTB" style="margin-bottom: 0;">
                            <img src="../../assets/works/beny5.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                For Work, For Life
                            </div>
                            <p class="beny_card-text" style="margin-bottom: 11px;">
                                Beny considers the mental, financial, physical, and <br>social wellbeing of your employees. We’re an employee<br> wellbeing solution that understands and supports the <br>whole person, holistically. 
                            </p>
                            <p class="beny_card-text">
                                Because successful teams = successful organisations.
                            </p>
                        </div>
                        <!--<div class="beny_cardBox">
                            <img src="../../assets/works/beny6.png" class="beny_icon" alt="">
                            <div class="beny_card-title">
                                We're here for you <br/>
                                whatever you need
                            </div>
                            <p class="beny_card-text">
                                Briefly expand on how this <br/>
                                will help your customers.
                            </p>
                        </div>-->
                    </div>
                </div>
            </div>
            <!--<div class="carousel_box">
                <h3 class="bold_primaryText centerText margin40">
                    What our lovely users <br/>
                    say about us
                </h3>
                <carouselCard/>
            </div>-->
            <section class="footerBox">
                <div class="footerBox_main">
                    <div class="centerFooter">
                        <div class="footerLeft">
                            <h2 class="footTitle">Become a Beny Organisation today.</h2>
                            <p class="footText">Ready to become fast friends with Beny? Sign up today in less time than it takes to make a coffee and give your employees not only access to 1000’s of big-name benefits, but the valuable wellness and wellbeing support that gets them from nine to thrive.</p>
                            <div class="default_Btn footerBtn" @click="$router.push('/registered')">Get started</div>
                        </div>
                        <div class="footerRight"></div>
                    </div>
                </div>
            </section>
        </section>
    </div>
</template>

<script>
import carouselCard from '../common/card-carousel.vue'
export default {
    components:{carouselCard},
    methods: {
        openSeeHow(){
            // Utils.alert('','没有链接','error')
        }
    },
}
</script>

<style lang="scss" scoped>
.works-page{
    .title-margin{
        padding-top:145px;
        margin-bottom: 30px;
    }
    .pfp-txt{
        box-sizing: border-box;
        padding-left: 50px;
        background-repeat: no-repeat;
        background-size: 40px auto;
        background-position: left center;
        background-image: url('../../assets/home/pfp.png');
        height: 50px;
        font-size: 15px;
        font-family: Assistant;
        color: #FFFFFF;
        line-height: 50px;
        span{
            font-family: Assistant-Bold;
        }
    }
    .top-contentBox{
        width: 100%;
        height: 634px;
        background-color: #f1dadd;
        padding: 127px 0 0 0;
        position: relative;
        .mar-btm-130{
            margin-bottom: 20px;
        }
        .marginText{
            margin: 0 0 60px 0;
        }
        .w164{
            width: 164px;
            margin: 0 auto 50px auto;
        }
        .topLong_icon{
            width: 100%;
            height: 371px;
            background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/32f743450f68436fb749d4e3bbbf85e6.png') no-repeat;
            background-size: cover;
            background-position-x: -187px;
            overflow: hidden;
        }
    }
    .middle-contentBox{
        padding: 107px 0 89px 0;
        .mid_center{
            width: 1280px;
            margin: 0 auto;
            .new_tips{
                font-size: 40px;
                font-family: Assistant-Medium, Assistant;
                font-weight: 500;
                color: #FFFFFF;
                line-height: 47px;
                .height_box{
                    height: 11px;
                    width: 100%;
                }
            }
            .mid_btmBox{
                display: flex;
                margin-top: 96px;
                .mid_btmLeft{
                    .margin_mid{
                        margin: 20px 0 24px;
                    }
                    .w242{
                        width: 242px;
                    }
                }
                .mid_btmRight{
                    width: 565px;
                    min-width: 565px;
                    height: 500px;
                    margin-left: auto;
                }
            }
        }
    }
    .footer-contentBox{
        margin-top: -53px;
        padding-top: 59px;
        background: linear-gradient(180deg, #302E2C 0%, rgba(48, 46, 44, 0) 100%);
        .fot_center{
            width: 1300px;
            margin: 0 auto;
            .footer_cardBox{
                display: flex;
                .footerCard_img{
                    width: 491px;
                    height: 457px;
                }
                .footerCard_img2{
                    width: 400px;
                    height: 517px;
                }
                .footerCard_img3{
                    width: 460px;
                    height: 451px;
                }
                .footCard_item{
                    .margin_fot{
                        margin-top: 20px;
                    }
                    .marginTop26{
                        margin-top: 26px;
                    }
                    .marginTop70{
                        margin-top: 70px;
                    }
                    .w222{
                        width: 222px;
                        margin-top: 24px;
                    }
                    .dashedLine{
                        width: 420px;
                        height: 0px;
                        border: 1px dashed #FFFFFF;
                        opacity: 0.18;
                        margin: 31px 0 24px 0;
                    }
                    .userInfo_box{
                        display: flex;
                        margin-top: 24px;
                        height: 40px;
                        align-items: center;
                        font-size: 16px;
                        color: #FFFFFF;
                        font-weight: bold;
                        .userIcon{
                            width: 40px;
                            height: 40px;
                            border-radius: 50%;
                            margin-right: 10px;
                        }
                        .userJob_box{
                            font-size: 15px;
                            font-weight: normal;
                            opacity: 0.8;
                            margin:0 0 0 5px;
                        }
                    }
                }
                .left31{
                    margin-left: -31px;
                }
                .leftAuto{
                    margin-left: 60px;
                }
            }
        }
        .fot_middle{
            margin: 122px 40px 90px 40px;
            width: calc(100% - 80px);
            background:#4e4c4a;
            border-radius: 0px;
            .fotMid_center{
                width: 1280px;
                margin: 0 auto;
                padding: 100px 0;
                display: flex;
                .fotMid_secondBox{
                    .beny_cardBox{
                        .beny_icon{
                            height: 44px;
                        }
                        .beny_card-title{
                            font-size: 22px;
                            font-family: Lora-Roman, Lora;
                            font-weight: normal;
                            line-height: 27px;
                            color: #FFFFFF;
                            opacity: 1;
                            margin: 24px 0 12px 0;
                        }
                        .beny_card-text{
                            font-size: 17px;
                            font-weight: 400;
                            line-height: 21px;
                            color: #FFFFFF;
                            opacity: 0.8;
                        }
                    }
                    .marginTB{
                        margin: 60px 0;
                    }
                }
                .marginCenter{
                    margin: 0 156px 0 88px;
                }
            }
        }
    }
    .carousel_box{
        width: 1080px;
        margin: 0 auto;
        .margin40{
            margin:0 0 40px 0;
        }
    }
    .footerBox{
        width: 100%;
        min-width: 1400px;
        padding: 0 40px;
        background: #3A3835;
        .footerBox_main{
            height: 461px;
            background: #F1DADD;
            opacity: 1;
            box-sizing: border-box;
            border-radius: 0px;
            margin-top: 190px;
        }
        .centerFooter{
            display: flex;
            width: 1300px;
            margin: 0 auto;
            .footerLeft{
                .footTitle{
                    margin-top: 60px;
                    width: 680px;
                    font-size: 52px;
                    font-family: DIN Next LT Pro-Black, DIN Next LT Pro;
                    font-weight: 900;
                    color: #3A3835;
                    line-height: 67px;
                }
                .footText{
                    margin: 18px 0 24px 0;
                    font-size: 18px;
                    font-family: Assistant-Medium, Assistant;
                    font-weight: 500;
                    color: #3A3835;
                    line-height: 22px;
                }
                .footerBtn{
                    font-size: 17px;
                    font-family: Assistant-Bold, Assistant;
                    font-weight: bold;
                    color: #3A3835;
                    width: 222px;
                    margin: 0;
                }
            }
            .footerRight{
                margin-left: 115px;
                margin-top: -60px;
                width: 505px;
                min-width: 505px;
                height: 422px;
                background: url('https://beny-admin-bucket.s3.us-west-2.amazonaws.com/png/2023/08/03/706f49fe327d49ae89e4ee44bb68ba94.png') no-repeat;
                background-size: contain;
                opacity: 1;
                border-radius: 8px;
            }
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/works/works.vue